import axios, { AxiosResponse } from "axios";
import { equivalenceAuthObject, storage } from "store";
import { SetterOrUpdater } from "recoil";
import { _goToVerifyCode } from "router/helper";

export const onInsertMobileResponse = () => _goToVerifyCode();

export const onVerifyCodeResponse = (
  res: AxiosResponse,
  setAuth: SetterOrUpdater<AuthDataT>
) => {
  const data = res.data;

  axios.defaults.headers.common.Authorization = "Bearer " + data.token;
  setAuth(equivalenceAuthObject(data));
  storage.set(equivalenceAuthObject(data));
};

export const onLogoutResponse = (props: {
  setAuth: SetterOrUpdater<AuthDataT>;
  setCart: SetterOrUpdater<CartDataT>;
}) => {
  delete axios.defaults.headers.common.Authorization;
  props.setAuth(null);
  props.setCart(null);
  storage.set(null);
};
